module.exports = __webpack_public_path__ + "static/29-f2702994389db986c02009f50d8a852f.jpg";